export default {
      id: "reports-usage",
      viewBox: "0 0 25 26.38",
      url: __webpack_public_path__ + "assets/images/lantern-icons.svg#reports",
      toString: function () {
        return this.url;
      }
    }